import styled from 'styled-components';

import colors from '../../../../../../../styles/colors';
import { Title } from '../../../../../../../components/v2/Header';

const StatisticCard = styled.div`
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 10px;
  padding: 15px;
  background-color: ${colors.base.alpha};
  width: fit-content;
  min-width: 220px;
  display: flex;
  flex-direction: column;
`;

const StyledTitle = styled(Title)`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.shades.secondary3};
`;

const CountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 35px;
`;

export {
  StatisticCard,
  StyledTitle,
  CountContainer,
};
